
import { Typography } from "@material-ui/core"
import "../../../assets/css/main.css";
import AvatarPicture from "./AvatarPicture";
import AppInitSingletonBo from "../../../consumer/init/AppInitSingletonBo";
import Menue from "./Menue";
import useCssMediaQuery from "../../useCssMediaQuery";

const AgenturAvatar: React.FC = () => {
    const vmnr = AppInitSingletonBo.vermittler?.vmnr;
    const agtName1 = AppInitSingletonBo.vermittler?.agtName1;
    const render = AppInitSingletonBo.renderAgentur();

    const cssMediaQuery = useCssMediaQuery();

    return (
        render ? (
            <div style={{ marginTop: 10, display: 'flex', marginRight: 10, alignItems: 'center' }}>
                {!cssMediaQuery.handyVersion &&
                    <div style={{ marginRight: 10, textAlign: 'right' }}>
                        <Typography color='textPrimary' variant='body2'>Ihr Ansprechpartner:</Typography>
                        <Typography color='textPrimary' variant='subtitle2' style={{ fontSize: 16 }}>{agtName1}</Typography>
                    </div>

                }
                {!cssMediaQuery.handyVersion &&
                    <AvatarPicture vmnr={vmnr} />
                }
                <div style={{ marginLeft: 10 }}>
                    <Menue />
                </div>
            </div>) : null
    );
}

export default AgenturAvatar;